import { Box, Typography } from "@mui/material";
import PageHeader from "components/PageHeader";
import buildRoute from "components/buildRoute";

export function ProjectWelcomePage() {
  return (
    <>
      <PageHeader
        title="Welcome to PAD!"
        subtitle="Get started by selecting a link from the sidebar."
      />

      <Box component="section">
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            pt: 6,
            pb: 4,
          }}
        >
          <Box
            component="img"
            src="/static/images/prog.png"
            alt="Prog"
            sx={{
              width: { xs: 200, sm: 250, md: 300 },
              height: "auto",
              mb: 4,
            }}
          />
        </Box>
      </Box>
    </>
  );
}

const routeArgs = {
  element: <ProjectWelcomePage />,
  loader: async () => {
    return {};
  },
};

export default buildRoute(routeArgs);